"use client";

import type { TherapyDirectoryFilters } from "~/lib/therapy-directory-filters";
import DirectoryFilterSelects from "./directory-filter-selects";
import DirectoryModeTabs from "./directory-mode-tabs";
import TopicSwitcher from "./topic-switcher";

interface DirectoryTopicModeBarProps {
  filters: TherapyDirectoryFilters;
  topic?: {
    slug: string;
    label: string;
  };
  isCouplesOnlyRoute: boolean;
  isPending: boolean;
  onUpdate: (updates: Record<string, string | undefined>) => void;
  showFilters?: boolean;
}

/** The shared topic-search and therapy-mode entry point for therapy directories. */
export default function DirectoryTopicModeBar({
  filters,
  topic,
  isCouplesOnlyRoute,
  isPending,
  onUpdate,
  showFilters = false,
}: DirectoryTopicModeBarProps) {
  return (
    <div>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        <div className="min-w-0 flex-1">
          <TopicSwitcher
            specialtySlug={topic?.slug}
            specialtyLabel={topic?.label}
          />
        </div>
        {showFilters && (
          <div className="hidden shrink-0 lg:block">
            <DirectoryFilterSelects
              filters={filters}
              isPending={isPending}
              onUpdate={onUpdate}
            />
          </div>
        )}
        <DirectoryModeTabs
          filters={filters}
          isCouplesOnlyRoute={isCouplesOnlyRoute}
          isPending={isPending}
          onUpdate={onUpdate}
        />
      </div>
      {showFilters && (
        <div className="mt-3 hidden md:flex lg:hidden">
          <DirectoryFilterSelects
            filters={filters}
            isPending={isPending}
            onUpdate={onUpdate}
          />
        </div>
      )}
    </div>
  );
}
